import { render, staticRenderFns } from "./Qunshu.vue?vue&type=template&id=52a356a3&scoped=true&"
import script from "./Qunshu.vue?vue&type=script&lang=js&"
export * from "./Qunshu.vue?vue&type=script&lang=js&"
import style0 from "./Qunshu.vue?vue&type=style&index=0&id=52a356a3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a356a3",
  null
  
)

export default component.exports